import { Button } from '@mui/material'

import { CustomInsightStatus } from '../../types/CustomInsight'

import { copy } from '../../Copy'

interface StatusLinkProps {
  copy: typeof copy
  fontSize?: number
  status: number
  sx?: React.CSSProperties
}

export const StatusLink: React.FC<StatusLinkProps> = ({ copy, fontSize, status, sx }) => {
  return (
    <Button
      color={status === CustomInsightStatus.Active ? 'secondary' : 'primary'}
      disabled={status === CustomInsightStatus.Pending}
      sx={{
        fontSize: fontSize,
        ...sx,
      }}
      /* TODO hook up button when backend is ready*/
      onClick={() => {}}
    >
      {status === CustomInsightStatus.Disabled ? copy.activate : copy.disable}
    </Button>
  )
}
